import { forwardRef } from 'react';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
	id: string;
	name: string;
	type: string;
};

const Input = forwardRef<HTMLInputElement, InputProps>((props: InputProps, ref) => {
	return <input ref={ref} {...props}></input>;
});

export { Input };
